import {
  INVOICE_STATUSES,
  INVOICE_STATUS_LABELS,
  ORDER_STATUSES,
  ORDER_STATUS_LABELS,
  PLAN_LABELS,
  ROLE_LABELS,
  SETTLEMENT_TYPE_LABELS,
  type InvoiceStatus,
  type OrderStatus,
  type Plan,
  type SettlementType,
  type WorkspaceRole,
} from "@bizy/core";
import { Badge } from "../ui/badge";

type BadgeTone = "default" | "secondary" | "outline" | "success" | "warning" | "danger";

const ORDER_TONES: Record<OrderStatus, BadgeTone> = {
  [ORDER_STATUSES.draft]: "outline",
  [ORDER_STATUSES.unpaid]: "warning",
  [ORDER_STATUSES.partiallyPaid]: "warning",
  [ORDER_STATUSES.paid]: "success",
  [ORDER_STATUSES.cancelled]: "danger",
  [ORDER_STATUSES.completed]: "secondary",
};

const INVOICE_TONES: Record<InvoiceStatus, BadgeTone> = {
  [INVOICE_STATUSES.issued]: "default",
  [INVOICE_STATUSES.paid]: "success",
  [INVOICE_STATUSES.void]: "danger",
};

export const OrderStatusBadge = ({ status }: { status: OrderStatus }) => (
  <Badge variant={ORDER_TONES[status]}>{ORDER_STATUS_LABELS[status]}</Badge>
);

export const InvoiceStatusBadge = ({ status }: { status: InvoiceStatus }) => (
  <Badge variant={INVOICE_TONES[status]}>{INVOICE_STATUS_LABELS[status]}</Badge>
);

export const SettlementBadge = ({ type }: { type: SettlementType }) => (
  <Badge variant={type === "full" ? "secondary" : "outline"}>{SETTLEMENT_TYPE_LABELS[type]}</Badge>
);

export const RoleBadge = ({ role }: { role: WorkspaceRole }) => (
  <Badge variant={role === "workspace_owner" ? "default" : "outline"}>{ROLE_LABELS[role]}</Badge>
);

export const PlanBadge = ({ plan }: { plan: Plan }) => (
  <Badge variant={plan === "pro" ? "success" : "outline"}>{PLAN_LABELS[plan]}</Badge>
);
